import Layout from './layout';

import { AuthProvider as KeyCloakProvider } from 'react-oidc-context';
import { oidcConfig } from '../utils/oidcConfig';
import { KeycloakAuthManager } from './keycloak-auth-manager';

export function App() {
  return (
    <KeyCloakProvider {...oidcConfig}>
      <KeycloakAuthManager />
      <Layout />
    </KeyCloakProvider>
  );
}

export default App;
